import { DateTime, Duration, Interval } from "luxon";
import { Model } from '../../../common/models/base';
import {
    UnitsStruct, Units, CurrencyStruct, Currency, FuelPreferenceStruct, FuelPreference, VolumeBasedFee
} from '../../../common/models';
import {Round, RoundStruct, Tender, TenderStruct
} from '..';
import { LocationStruct, Location } from '../../../geodata/models';
import {IndexStruct} from "../../../indexes/models/index-provider";
import {FuelType, FuelTypeStruct} from "../../../common/models/fuel-type";
import {Offer, OfferStruct} from "../offer";
import {Company, CompanyStruct} from "../../../auth/models";

export interface ContractOffersStruct {
    id?: number;
    offers: OfferStruct[];
    current_offers: OfferStruct[];
    mock_offers: OfferStruct[];
    volume?: number;
    annual_frequency?: number;
    award_quota?: number;
    date_start?: string;
    date_end?: string;
    index?: IndexStruct;
    location?: LocationStruct;
    location_id?: number;
    units?: UnitsStruct;
    units_id?: number;
    currency?: CurrencyStruct;
    currency_id?: number;
    fuel_preference?: FuelPreferenceStruct;
    fuel_preference_id?: number;
    current_round?: RoundStruct;
    iata_service_level?: number;
    fuel_type?: FuelTypeStruct;
    company_info?: string;
    branded?: boolean;
    company_child?: CompanyStruct;
    month_service?: string;
    average_uplift?: string;
    tender?: TenderStruct;
    date_range?: string;
}

export class ContractOffers implements Model<ContractOffersStruct> {

    constructor(
        public volume: number,
        public offers: Offer[],
        public currentOffers: Offer[],
        public mockOffers: Offer[],
        public awardQuota: number,
        public dateStart?: DateTime,
        public dateEnd?: DateTime,
        public id?: number,
        public location?: Location,
        public units?: Units,
        public currency?: Currency,
        public fuelPreference?: FuelPreference,
        public currentRound?: Round,
        public index?: IndexStruct,
        public iataServiceLevel?: number,
        public fuelType?: FuelType,
        public companyInfo?: string,
        public branded?: boolean,
        public companyChild?: Company,
        public monthService?: string,
        public averageUplift?: string,
        public annualFrequency?: number,
        public tender?: Tender,
        public dateRange?: string,
    ) {

    }

    public static create(data: ContractOffersStruct) {
        let dateStart = data.date_start ?  data.date_start : null;
        let dateEnd = data.date_end ?  data.date_end : null;

        dateStart = this.clearDate(dateStart);
        dateEnd = this.clearDate(dateEnd);

        if (dateStart){
            dateStart = DateTime.fromISO(data.date_start, { zone: "utc" })
        }
        if (dateEnd){
            dateEnd = DateTime.fromISO(data.date_end, { zone: "utc" })
        }

        return new ContractOffers(
            data.volume || null,
            data.offers ? data.offers.map((item) => Offer.create(item)) : null,
            data.current_offers ? data.current_offers.map((item) => Offer.create(item)) : null,
            data.mock_offers ? data.mock_offers.map((item) => Offer.create(item)) : null,
            data.award_quota || null,
            dateStart,
            dateEnd,
            data.id || null,
            data.location ? Location.create(data.location) : null,
            data.units ? Units.create(data.units) : null,
            data.currency ? Currency.create(data.currency) : null,
            data.fuel_preference ? FuelPreference.create(data.fuel_preference) : null,
            data.current_round ? Round.create(data.current_round) : null,
            data.index || null,
            data.iata_service_level || null,
            data.fuel_type ? FuelType.create(data.fuel_type) : null,
            data.company_info || null,
            data.branded ?? false,
            data.company_child ? Company.create(data.company_child) : null,
            data.month_service || null,
            data.average_uplift || null,
            data.annual_frequency || null,
            data.tender ? Tender.create(data.tender) : null,
            data.date_range || null,
        );
    }

    private static clearDate(dateStart: string) {
        if (dateStart && dateStart.length > 10) {
            dateStart = dateStart.slice(0, 10)
        }
        return dateStart;
    }

    clone(): any {
    }

    toForm(): any {
    }

    toJSON(): ContractOffersStruct {
        return undefined;
    }

    update(data: ContractOffersStruct): this {
        return undefined;
    }
}
